<script>
  import { onMount, getContext } from "svelte";
  import { UsersRepository, GroupsRepository } from "../../repositories/index";
  import { _, callout } from "../../stores/index";
  import {
    AssignmentGrid,
    MissingPoliciesCallout,
  } from "../../components/index";
  import { ActionFooter, Button, Loader } from "@gl/design-system";
  import { navigate } from "../../utils/index";
  const { isAuthorized } = getContext("isAuthorized");

  export let id;
  export let group;

  let assignmentGrid;
  let assignmentGridObj = {};

  let groupUsers = [];
  let allUsers = [];

  const loading = {};

  async function handleSave() {
    loading.save = true;

    const selected = assignmentGrid.getCurrent();

    const usersToAdd = selected.all
      ? selected.all.filter((uID) => !groupUsers.some((ru) => ru.id === uID))
      : [];

    const usersToRemove = selected.all
      ? groupUsers.filter((ru) => !selected.all.includes(ru.id.toString()))
      : groupUsers;

    try {
      if (usersToAdd.length)
        await GroupsRepository.addGroupUser(id, {
          users: usersToAdd,
        });

      if (usersToRemove.length)
        await GroupsRepository.deleteGroupUser(id, {
          users: usersToRemove.map((u) => u.id.toString()),
        });
    } finally {
      fetchUsers();
      loading.save = false;
    }

    if (usersToAdd.length || usersToRemove.length) {
      let calloutMsg = "";
      if (usersToAdd.length)
        calloutMsg += `${usersToAdd.length} ${$_("assignment.callout.users.added")}`;
      if (usersToRemove.length)
        calloutMsg += `${usersToRemove.length} ${$_("assignment.callout.users.removed")}`;

      callout.set({
        msg: calloutMsg,
        status: "success",
        timeout: true,
      });
    } else {
      callout.set({
        msg: $_("common.nochanges"),
        status: "warning",
        timeout: true,
      });
    }

    navigate("/groups");
  }

  function mapMembers() {
    assignmentGridObj = {
      available: [],
      current: [],
    };

    const mapUser = (u) => ({
      id: u.id.toString(),
      label: `${u.firstName} ${u.lastName}`,
      info: u.email,
      type: "user",
    });

    const mappedRoleUsers = groupUsers.map(mapUser);
    assignmentGridObj.current.push(...mappedRoleUsers);

    const mappedAllUsers = allUsers
      .filter((u) => !groupUsers.some((gu) => gu.id === u.id))
      .map(mapUser);
    assignmentGridObj.available.push(...mappedAllUsers);

    assignmentGridObj.current.sort((a, b) => a.label.localeCompare(b.label));
    assignmentGridObj.available.sort((a, b) => a.label.localeCompare(b.label));
    loading.users = false;
  }

  async function fetchUsers() {
    loading.users = true;
    try {
      const groupUsersList = await GroupsRepository.getGroupUsers(id);
      groupUsers = groupUsersList.list;

      const allUsersList = await UsersRepository.getUsers();
      allUsers = allUsersList.list;
    } finally {
      mapMembers();
    }
  }

  onMount(() => {
    fetchUsers();
  });
</script>

<svelte:head>
  <title>
    {$_("layout.group.members")}: {group.id} | {$_("common.groups")} | {$_(
      "access-manager",
    )}
  </title>
</svelte:head>

{#if loading.users !== false}
  <Loader />
{:else}
  {#if group.missingPolicies}
    <MissingPoliciesCallout type="group" />
  {/if}

  <AssignmentGrid
    data={assignmentGridObj}
    bind:this={assignmentGrid}
    disabled={!($isAuthorized("group_write") && $isAuthorized("user_write")) ||
      group.missingPolicies}
    checkboxes={false}
  />
  {#if $isAuthorized("group_write") && $isAuthorized("user_write")}
    <ActionFooter>
      <svelte:fragment slot="left">
        <Button on:click={() => assignmentGrid.reset()} outlined
          >{$_("common.reset")}</Button
        >
      </svelte:fragment>
      <Button on:click={handleSave} loading={loading.save}
        >{$_("buttons.save")}</Button
      >
      <Button on:click={() => navigate("/groups")} outlined
        >{$_("buttons.cancel")}</Button
      >
    </ActionFooter>
  {/if}
{/if}
